import React from 'react';
import { useForm, Link } from '@inertiajs/react';
import AuthLayout from '../layouts/AuthLayout';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';

export default function SignIn({ email_hint, csrf_token }) {
  const form = useForm({
    defaultValues: {
      email: email_hint || '',
      password: '',
      authenticity_token: csrf_token
    }
  });

  const { data, setData, post, processing, errors } = useForm({
    email: email_hint || '',
    password: '',
    authenticity_token: csrf_token
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    post('/sign_in');
  };

  return (
    <AuthLayout 
      title="Sign in to your account"
      description="Enter your credentials to access your account"
    >
      <form className="space-y-6" onSubmit={handleSubmit}>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email address</Label>
            <Input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              required
              placeholder="name@example.com"
              value={data.email}
              onChange={e => setData('email', e.target.value)}
            />
            {errors.email && <p className="text-sm text-destructive mt-1">{errors.email}</p>}
          </div>
          
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <Label htmlFor="password">Password</Label>
              <Link 
                href="/identity/password_reset/new" 
                className="text-sm font-medium text-primary hover:underline"
              >
                Forgot password?
              </Link>
            </div>
            <Input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
              placeholder="••••••••"
              value={data.password}
              onChange={e => setData('password', e.target.value)}
            />
            {errors.password && <p className="text-sm text-destructive mt-1">{errors.password}</p>}
          </div>
        </div>

        <Button
          type="submit"
          className="w-full"
          disabled={processing}
        >
          {processing ? 'Signing in...' : 'Sign in'}
        </Button>

        <div className="text-center mt-6">
          <p className="text-sm text-muted-foreground">
            Don't have an account?{' '}
            <Link href="/sign_up" className="font-medium text-primary hover:underline">
              Sign up
            </Link>
          </p>
        </div>
      </form>
    </AuthLayout>
  );
}
